// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2JfDd","nodata":"styles_nodata__39zOe","credits":"styles_credits__2ouPR","extract":"styles_extract__ypxs4"};